module.exports = __webpack_public_path__ + "img/clerk_accounting_1.e5b78376.png";